import React, { useEffect, useState } from "react";
import "./pages.css";

import Table from "react-bootstrap/Table";
import { firebase } from "../firebase";
import { Button } from "react-bootstrap";

const AnnualReport = () => {
  useEffect(() => {
    document.title = " Financial Report | Star Adhesives";
  }, []);
  const [tableData, setTableData] = useState({});
  const [tableData2, setTableData2] = useState({});
  useEffect(() => {
    firebase
      .database()
      .ref("StarAdhesive")
      .child("UploadFiles")
      .child("FinancialStatement")
      .on("value", (snapshot) => {
        if (snapshot.val() != null) {
          setTableData2({ ...snapshot.val() });
        }
      });
  }, []);
  useEffect(() => {
    firebase
      .database()
      .ref("StarAdhesive")
      .child("UploadFiles")
      .child("AnnualReport")
      .on("value", (snapshot) => {
        if (snapshot.val() != null) {
          setTableData({ ...snapshot.val() });
        }
      });
  }, []);
  return (
    <>
      <div className="aboutUs">
        <div class="bod ">
          <img src="assets/images/BOD.jpg" />
          <div className="titleText">
            <h2> Financial Report</h2>
          </div>
        </div>
      </div>

      <div className="bodsec2">
        <div className="container fluid">
          <div className="row">
            <h2>Annual Report</h2>
            <hr />
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Sl.</th>
                  <th>File Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(tableData).map((id, index) => {
                  return (
                    <tr key={id}>
                      <td>{index + 1}</td>
                      <td>{tableData[id].FileName}</td>
                      <td>
                        <Button
                          href={tableData[id].DownloadUrl}
                          variant="primary"
                          size="md"
                          target="_blank"
                        >
                          Download
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      <div className="bodsec2">
        <div className="container fluid">
          <div className="row">
            <h2>Financial Statement</h2>
            <hr />
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Sl.</th>
                  <th>File Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(tableData2).map((id, index) => {
                  return (
                    <tr key={id}>
                      <td>{index + 1}</td>
                      <td>{tableData2[id].FileName}</td>
                      <td>
                        <Button
                          href={tableData2[id].DownloadUrl}
                          variant="primary"
                          size="md"
                          target="_blank"
                        >
                          Download
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnnualReport;
